import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HrBaseElementComponent } from '../hr-base-element/hr-base-element.component';

@Component({
    selector: 'hr-form-dropdown',
    templateUrl: './hr-form-dropdown.component.html',
})
export class HrFormDropdownComponent extends HrBaseElementComponent implements OnInit {
    @Input() options: Array<any>;
    @Input() optionValue: string;
    @Input() optionLabel: string;
    @Input() filter?: boolean;
    @Input() readonly?: boolean;
    @Input() disabled?: boolean;
    @Output() onChange? = new EventEmitter<any>();
    @Output() ngModelChange? = new EventEmitter<any>();

    onChangeEvent(selectedItem: any): void {
        this.onChange?.emit(selectedItem);
    }

    ngModelChangeEvent(selectedItem: any): void {
        this.ngModelChange?.emit(selectedItem);
    }
}
